import type {PageListInterface as PageListRequest} from "~/api/interfaces/PageListInterface";
import api from "~/api/api";
import type {PageListInterface} from "~/interfaces/PageListInterface";
import type {Page as PageEntity} from "~/interfaces/Page";
import {Taxonomy} from "~/dto/Taxonomy";

export class Page {

    static get(params: PageListRequest = {}): Promise<PageListInterface> {
        const defaultParams: PageListRequest = {
            page: 1,
            limit: 20,
            only_active_taxonomy: 1,
        };
        params = {...defaultParams, ...params};
        return api("/pages/index", params);
    }

    static getInfo(id: number): Promise<PageEntity> {
        return api("/pages/info", {id});
    }

    static getBySlug(slug: string): Promise<PageEntity> {
        return api("/pages/by-slug", {slug});
    }

    static search(term: string, limit: number = 5): Promise<PageListInterface> {
        return api("/pages/index", {search: term, limit, only_active_taxonomy: 0});
    }

    static async getTaxonomies(): Promise<Taxonomy[]> {
        const data = await api("/page-taxonomies/index", { only_active: 1 });
        return data.map((el: any) => Taxonomy.createFromObj(el));
    }

    static getTaxonomyInfo(id: number): Promise<any> {
        return api("/page-taxonomies/info", { id });
    }

}